(function() {
  'use strict';

  var released = false;
  var waitingForDOM = false;
  var releaseTimer;
  var activityEvents = ['mousedown', 'mousemove', 'keydown', 'scroll', 'touchstart', 'click', 'keypress', 'touchmove'];
  var adClickIds = /[?&](?:gclid|gbraid|wbraid|gad_source|dclid|fbclid|ttclid|msclkid|epik|li_fat_id|twclid|ScCid|rdt_cid)=/;
  var idle = window.requestIdleCallback ? window.requestIdleCallback.bind(window) : function(callback) { return setTimeout(callback, 16); };

  function loadExternal(script, url, insert, next) {
    var finished = false;
    var timeout = setTimeout(done, 4000);
    function done() {
      if (finished) return;
      finished = true;
      clearTimeout(timeout);
      script.removeEventListener('load', done);
      script.removeEventListener('error', done);
      next();
    }
    script.addEventListener('load', done);
    script.addEventListener('error', done);
    try {
      script.src = url;
      insert();
    } catch (error) {
      done();
    }
  }

  function loadJSscripts() {
    if (released || document.prerendering) return;
    if (document.readyState === 'loading') {
      if (!waitingForDOM) document.addEventListener('DOMContentLoaded', loadJSscripts, { once: true });
      waitingForDOM = true;
      return;
    }
    released = true;
    window.script_loaded = true;
    clearTimeout(releaseTimer);
    activityEvents.forEach(function(event) { window.removeEventListener(event, loadJSscripts); });
    document.removeEventListener('visibilitychange', onVisibilityChange);

    var queue = [];
    function enqueue(work) {
      queue.push(function(next) { try { work(); } finally { next(); } });
    }
    enqueue(function() { if (window.yett) window.yett.unblock(); });
    document.querySelectorAll('script[data-src]:not([type="text/lazyload"])').forEach(function(script) {
      queue.push(function(next) {
        if (!script.parentNode || script.getAttribute('src')) return next();
        loadExternal(script, script.dataset.src, function() {}, next);
      });
    });
    document.querySelectorAll('link[data-href]').forEach(function(link) {
      enqueue(function() { link.href = link.dataset.href; });
    });
    document.querySelectorAll('iframe[data-deferred-video]').forEach(function(frame) {
      enqueue(function() {
        if (!frame.parentNode) return;
        frame.src = frame.getAttribute('data-deferred-video');
        frame.removeAttribute('data-deferred-video');
        frame.removeAttribute('data-src');
      });
    });
    enqueue(function() { document.dispatchEvent(new CustomEvent('asyncLazyLoad')); });

    document.querySelectorAll('script[type="text/lazyload"]').forEach(function(script) {
      queue.push(function(next) {
        if (!script.parentNode) return next();
        var match = script.getAttribute('data-app-match');
        if (match && Array.prototype.some.call(document.querySelectorAll('script[src]'), function(existing) {
          return existing !== script && existing.getAttribute('src').indexOf(match) !== -1;
        })) {
          script.parentNode.removeChild(script);
          return next();
        }
        var copy = document.createElement('script');
        Array.prototype.forEach.call(script.attributes, function(attribute) {
          if (!/^(src|type|data-src|data-app-match)$/.test(attribute.name)) copy.setAttribute(attribute.name, attribute.value);
        });
        copy.type = script.getAttribute('data-type') || 'text/javascript';
        copy.textContent = script.textContent;
        var src = script.getAttribute('data-src') || script.getAttribute('src');
        function insert() { script.parentNode.replaceChild(copy, script); }
        if (src) loadExternal(copy, src, insert, next);
        else { insert(); next(); }
      });
    });

    function next() {
      if (!queue.length) return;
      idle(function() { queue.shift()(next); }, { timeout: 200 });
    }
    next();
  }

  function fromAdClick() { return !!(window.location && adClickIds.test(window.location.search)); }
  function onVisibilityChange() { if (document.hidden) loadJSscripts(); }
  function releaseAfterLoad() { if (!released) releaseTimer = setTimeout(loadJSscripts, fromAdClick() ? 0 : 5000); }
  function onLoad() {
    if (document.prerendering) document.addEventListener('prerenderingchange', releaseAfterLoad, { once: true });
    else releaseAfterLoad();
  }

  activityEvents.forEach(function(event) { window.addEventListener(event, loadJSscripts, { passive: true }); });
  document.addEventListener('visibilitychange', onVisibilityChange);
  if (document.hidden || fromAdClick()) loadJSscripts();
  if (document.readyState === 'complete') onLoad();
  else window.addEventListener('load', onLoad, { once: true });
})();
